import React from 'react';
import {
  formatChartMetricTooltip,
  formatChartMetricWithShare,
  formatChartSharePercent,
  isChartRateMetric,
} from './chartFilterUtils';

/**
 * Floating hover detail for stacked distribution bars (absolute + % of bar).
 */
const StackedChartHoverTooltip = ({ ui, info }) => {
  if (!info) return null;
  const metricKey = info.metricKey || 'count';
  const showShare = !isChartRateMetric(metricKey);
  const rows = Array.isArray(info.rows) ? info.rows : [];

  return (
    <div
      role="tooltip"
      style={{
        position: 'fixed',
        left: Math.min(info.x + 14, (typeof window !== 'undefined' ? window.innerWidth : 1200) - 280),
        top: Math.min(info.y + 14, (typeof window !== 'undefined' ? window.innerHeight : 800) - 40),
        zIndex: 10060,
        minWidth: 180,
        maxWidth: 280,
        pointerEvents: 'none',
        background: ui.isDarkMode ? '#0f172a' : '#0f172a',
        color: '#f8fafc',
        border: `1px solid ${ui.isDarkMode ? '#334155' : '#1e293b'}`,
        borderRadius: 8,
        boxShadow: '0 10px 28px rgba(15, 23, 42, 0.35)',
        padding: '8px 10px',
        fontSize: 11,
        lineHeight: 1.35,
      }}
    >
      <div style={{ fontWeight: 750, marginBottom: 6 }}>{info.label}</div>
      <div style={{ color: '#cbd5e1', marginBottom: rows.length ? 6 : 0 }}>
        Total:{' '}
        <strong style={{ color: '#f8fafc' }}>
          {formatChartMetricTooltip(info.total, metricKey)}
        </strong>
        {showShare && info.chartTotal > 0 ? (
          <span style={{ color: '#94a3b8' }}>
            {' '}
            · {formatChartSharePercent(info.total, info.chartTotal)} del gráfico
          </span>
        ) : null}
      </div>
      {rows.length ? (
        <div style={{ display: 'grid', gap: 4 }}>
          {rows.map((row) => {
            const focused = info.focusSeries && info.focusSeries === row.series;
            return (
              <div
                key={row.series}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 8,
                  opacity: info.focusSeries && !focused ? 0.55 : 1,
                  fontWeight: focused ? 700 : 500,
                }}
              >
                <span
                  style={{
                    width: 8,
                    height: 8,
                    borderRadius: 999,
                    background: row.color || '#94a3b8',
                    flexShrink: 0,
                  }}
                />
                <span style={{ flex: 1, minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis' }}>
                  {row.series}
                </span>
                <span style={{ fontVariantNumeric: 'tabular-nums', whiteSpace: 'nowrap' }}>
                  {formatChartMetricWithShare(row.value, info.total, metricKey)}
                </span>
              </div>
            );
          })}
        </div>
      ) : null}
    </div>
  );
};

export default StackedChartHoverTooltip;
